// gsap, ScrollTrigger, SplitText, CustomEase are globals from PHP-enqueued vendor scripts

import { splitText }                from "./partials/split-text.js";
import { initializeMobileMenu }     from "./partials/mobile-nav.js";
import { initializeCustomSlider }   from "./partials/custom-slider.js";
import { initializeSingleSlider }   from "./partials/single-slider.js";
import { initializeButtonAnimations } from "./partials/button-animation.js";
import { initializeTypewriterEffect } from "./partials/typewriter-effect.js";
import { initializeToggleGallery }  from "./partials/toggle-gallery.js";
import { initializeComparisonTable } from "./partials/table-comparison.js";
import { initializeVideoPlayer }    from "./partials/video-player.js";
import { initializeShareToSocial }  from "./partials/share-to-social.js";
import { initializeTooltip }        from "./partials/tooltip.js";
import { initializeAccordion }      from "./partials/accordion-style.js";
import { initAccordion }            from "./partials/init-accordion.js";
import { showTeamMembers }          from "./partials/our-team.js";
import { initLetsTalkCounters }     from "./partials/counters.js";
import { headerAnimations }         from "./partials/header.js";
import { initializeStickyBox }      from "./partials/theme-customizer.js";
import { initTestimonialSlider }    from "./partials/testimonial-slider.js";
import { initMouseHoverAnimation }  from "./partials/mouse-hover-animation.js";
import { initReportSwiper }         from "./partials/report-swiper.js";
import { initFadeUpAnimations }         from "./partials/fade-up.js";
import { initBackToTop }            from "./partials/back-to-top.js";
import { initHashLinks }            from "./partials/hash-links.js";
// Self-executing IIFE, no exports — the widget lives outside #swup (wp_footer),
// so it initialises once and persists across page transitions.
import "./partials/floating-widget.js";
// Temporarily disabled: preload curtain + swup curtain page transitions. The
// markup is commented out in header.php and the styles in components/_all.scss.
// import { initPreloadCurtain }       from "./partials/preload-curtain.js";
// import { initPageTransitions }      from "./partials/page-transitions.js";

gsap.registerPlugin(SplitText, ScrollTrigger, CustomEase);
CustomEase.create("osmo-ease", "0.625, 0.05, 0, 1");

// Scripts for header/nav/footer markup, which live outside #swup and are
// never swapped out by a page transition — run these exactly once.
function initChromeScripts() {
    initializeMobileMenu();
    headerAnimations();
    initBackToTop();

    // Hash links point at ids anywhere in the document — header, footer and
    // the floating widget included — so this belongs with the chrome rather
    // than with the content swup swaps out.
    initHashLinks();

    // Language switcher
    document.querySelectorAll(".lang-switcher").forEach((switcher) => {
        const toggle   = switcher.querySelector(".lang-switcher__toggle");
        const dropdown = switcher.querySelector(".lang-switcher__dropdown");
        if (!toggle || !dropdown) return;

        toggle.addEventListener("click", () => {
            const isOpen = dropdown.classList.toggle("open");
            toggle.setAttribute("aria-expanded", isOpen);
        });
    });

    document.addEventListener("click", (e) => {
        if (!e.target.closest(".lang-switcher")) {
            document.querySelectorAll(".lang-switcher__dropdown").forEach(d => d.classList.remove("open"));
            document.querySelectorAll(".lang-switcher__toggle").forEach(t => t.setAttribute("aria-expanded", "false"));
        }
    });
}

// Scripts for #swup content. With page transitions disabled these only run on
// first load, but they stay grouped here so re-enabling swup needs no changes.
function initContentScripts() {
    const root = document.querySelector("#swup") || document;

    // Content just changed: any ScrollTriggers still pointing at the old,
    // now-detached page are dead weight — clear them before rebuilding.
    ScrollTrigger.getAll().forEach((st) => st.kill());

    initializeCustomSlider();
    initializeSingleSlider();
    initializeButtonAnimations(root);
    initializeTypewriterEffect();
    initializeToggleGallery();
    initializeComparisonTable();
    initializeVideoPlayer();
    initializeTooltip();
    initializeAccordion();
    initAccordion();
    showTeamMembers();
    initializeStickyBox();
    initLetsTalkCounters();
    initializeShareToSocial();
    initTestimonialSlider();
    initMouseHoverAnimation();
    initReportSwiper();
    initFadeUpAnimations();
}

// Kept separate from initContentScripts() because, with the curtain enabled,
// it has to wait for the curtain to clear: SplitText's masked-line reveal is
// scroll-triggered, so an above-the-fold heading would otherwise play out while
// still hidden. Runs straight after the content scripts while it's disabled.
function revealSplitText() {
    const root = document.querySelector("#swup") || document;
    splitText(root).then(() => ScrollTrigger.refresh());
}

document.addEventListener("DOMContentLoaded", () => {
    initChromeScripts();
    initContentScripts();
    revealSplitText();
    // initPreloadCurtain(revealSplitText);
    // initPageTransitions(initContentScripts, revealSplitText);
});
